import { useContext } from 'react';
import { SessionContext } from '@/providers/SessionProvider';
import { isPlayfulTheme } from '@/lib/layout-version';

// Perfis que seguem na sidebar corporativa mesmo em tenant lúdico.
const SIDEBAR_PROFILES = ['Administrador', '4 secretariado', 'Tutor', 'Designer Institucional'];
// Perfis que navegam pela bottom bar (tela sem sidebar).
const BOTTOM_BAR_PROFILES = ['Aluno', 'Professor'];

// Responde UMA pergunta: "esta sessão navega por bottom bar em vez de sidebar?".
//
// Não confunda com usePlayfulStudent(), que responde "posso renderizar a UI
// lúdica (mascote, cores, copy infantil)?" e continua valendo só para aluno. O
// professor entra aqui (bottom bar, sem sidebar) mas NÃO lá: o conteúdo dele
// segue corporativo. Todo gate de navegação/chrome — inclusive o botão de
// logout, que fora da sidebar só existe no perfil — deve usar este hook, senão
// o professor fica sem saída da conta.
//
// Sem sessão (tela pública ou fora do provider) vale o tema do tenant. Lê o
// SessionContext direto (sem throw) para não exigir provider em teste de
// unidade — ausência de provider ≡ sem sessão. Resolução last-match-wins igual
// à do useAuthorityLevel; perfil desconhecido cai na sidebar (default seguro,
// preserva acesso total à navegação).
export default function usePlayfulNav() {
  const context = useContext(SessionContext);
  const user = context?.session?.user;

  if (!isPlayfulTheme()) return false;
  if (!user) return true;

  const profiles = user.profileNames || user['profile-names'] || [];
  let target = '';
  profiles.forEach(profile => {
    if (SIDEBAR_PROFILES.includes(profile)) {
      target = 'sidebar';
    } else if (BOTTOM_BAR_PROFILES.includes(profile)) {
      target = 'bottom-bar';
    }
  });

  return target === 'bottom-bar';
}
